export default class DeviceProfileService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntitiesForSelectBox(params) {
		return this.apiService.callGet('deviceProfiles/simple', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('deviceProfile/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('deviceProfiles', params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('deviceProfile/' + id, params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('deviceProfile/' + id, params)
	}

	createEntity(params) {
		return this.apiService.callPost('deviceProfile/', params);
	}

	getDependency() {
		return this.apiService.callGet('deviceProfile/dependency/')
	}
}



// WEBPACK FOOTER //
// ./src/service/DeviceProfileService.js